import { WorkspaceSelector } from "@/components/WorkspaceSelector";
import { IS_ORGANIZATIONS_ENABLED } from "@/constants";
import { ChevronRight } from "lucide-react";
import SelectOrganization from "./SelectOrganization";
import SelectWorkspace from "./SelectWorkspace";

const OrganizationWorkspaceSelector = () => {
  if (!IS_ORGANIZATIONS_ENABLED) return <WorkspaceSelector />;
  return (
    <div className="flex items-center gap-1.5 p-1">
      <SelectOrganization />
      <div className="flex items-center text-gray-500">
        <ChevronRight className="h-3 w-3" />
      </div>
      <SelectWorkspace />
    </div>
  );
};

export default OrganizationWorkspaceSelector;
